import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowPathUp"><Path d="M3.12451 11H7.99998V22H16V11H20.8754L12 0.594238L3.12451 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathUp;
